<template>
  <GenericProgressLinear
    :icon="'mdi-chart-bar'"
    :title="'Stats'"
    :stats="stats"
  ></GenericProgressLinear>
</template>

<script>
import { mapGetters } from "vuex"

import GenericProgressLinear from "./GenericProgressLinear";

export default {
  name: "StatsProgressLinear",
  components: {
    GenericProgressLinear,
  },
  computed: {
    ...mapGetters("entities/areas", { statsAreas : "stats" }),
    ...mapGetters("entities/quests", { statsQuests : "stats" }),
    ...mapGetters("entities/bosses", { statsBosses : "stats" }),
    ...mapGetters("entities/secrets", { statsSecrets : "stats" }),
    ...mapGetters("entities/tomes", { statsTomes : "stats"}),
    ...mapGetters("entities/achievements", {statsAchievements: "stats"}),
    stats: function () {
      const stats = {};
      stats.total =
        this.statsAreas.total +
        this.statsQuests.total +
        this.statsBosses.total +
        this.statsSecrets.total +
        this.statsTomes.total +
        this.statsAchievements.total;
      stats.completed =
        this.statsAreas.completed +
        this.statsQuests.completed +
        this.statsBosses.completed +
        this.statsSecrets.completed +
        this.statsTomes.completed +
        this.statsAchievements.completed;
      stats.progress = Math.round((stats.completed / stats.total) * 100);
      return stats;
    },
  },
};
</script>